import { DateTime } from 'luxon';
import { DateTimeHelper } from '../../../../helpers/date-time.helper';

function DateHeader({ date, uniqueJourneyDates }: { date: DateTime; uniqueJourneyDates: DateTime[] }) {
  return (
    <div className={`py-2 px-3 bg-white border-bottom border-blue ${uniqueJourneyDates.length === 1 && DateTimeHelper.isSameDay(date, DateTime.now()) ? 'visually-hidden' : ''}`}>
      {DateTimeHelper.toLongDate(date, true)}
    </div>
  );
}

export default DateHeader;
